var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSpeakerOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6624 1.3932C16.6624 0.628082 16.0731 0 15.2481 0C14.6706 0 14.2816 0.239813 13.657 0.810797L8.81296 5.24163C8.74224 5.31015 8.67153 5.35583 8.58902 5.37867L8.1058 5.40151L16.6624 13.6922V1.3932ZM20.4457 21.7431C20.8111 22.0856 21.3886 22.0856 21.7304 21.7431C22.084 21.389 22.0957 20.8409 21.7304 20.4983L1.5528 0.947833C1.19922 0.605243 0.609924 0.605243 0.256345 0.947833C-0.0854483 1.279 -0.0854483 1.86141 0.256345 2.19258L20.4457 21.7431ZM4.62894 15.2909H8.14116C8.25902 15.2909 8.36509 15.3252 8.43581 15.3937L13.657 20.2014C14.2227 20.7153 14.6942 20.9437 15.2717 20.9437C15.8138 20.9437 16.2499 20.6696 16.4621 20.2699C16.5092 20.1671 16.5563 20.0529 16.5917 19.9273L2.66068 6.42928C2.27175 6.84038 2.07138 7.46847 2.07138 8.27926V12.6987C2.07138 14.4116 2.96712 15.2909 4.62894 15.2909Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeakerOff);
export default __webpack_public_path__ + "static/media/icon-speaker-off.b483788bb3e34e25f5e3ec8a96d34842.svg";
export { ForwardRef as ReactComponent };